<template>
    <div>
        <card shadow :class="['bg-secondary','shadow','border-'+cardStyle,isLoading ? 'loading-card' : '']"  shadow-size="5" :header-classes="'bg-'+cardStyle">

            <div slot="header" v-bind:class="'bg-'+cardStyle" class="border-0">
                <div class="row align-items-center">
                    <div class="col-3">
                        <h4 class="mb-0" :key="key+'cn1'" :class="[status.type !== '' ? 'text-white' : '']">{{(!isLoading) ? 'OASIS Check' : '' }} <i :key="key+'cnxc1'" v-if="isLoading" class="fas fa-circle-notch fa-spin"></i></h4>
                    </div>
                    <div :key="key+'btn451'" class="col-9 text-right">
                        <base-button v-if="reset"
                                     @click="setDefaultData"
                                     type="secondary" icon="fas fa-undo-alt" alt="zurück"></base-button>
                        <base-button v-if="mrzData !== null" v-on:click="checkPlayer" icon="fas fa-credit-card" alt="Kundenkarte erstellen"></base-button>
                        <base-button type="secondary" v-on:click="addOrEditPlayer" icon="fas fa-ban" alt="Spieler sperren"></base-button>
                        <base-button  v-on:click="checkPlayer" icon="fas fa-search" alt="Spieler prüfen"></base-button>
                    </div>
                </div>
            </div>
            <base-alert v-if="status.type !== '' && !status.showBlockedInfo" :type="status.type" autofocus>{{ status.message }}</base-alert>
                    <h6 v-if="!checkUserAgent('Flutter')" class="heading-small text-muted mb-4">Spieler information</h6>
                    <div class="row">
                        <div v-if="status.showBlockedInfo" class="col-lg-4 order-lg-last text-center">
                            <h1 v-if="playerBlocked" class="text-danger display-1">❌</h1>
                            <h1 v-else class="text-success display-1">✅</h1>
                            <base-alert :type="cardStyle">
                            <span class="text-white"> {{ status.message }} </span><font-awesome-icon v-if="sperrInfo.length > 0" icon="info-circle" @click="showSperrInfo = !showSperrInfo"></font-awesome-icon>
                                <ul v-if="showSperrInfo" class="pt-2">
                                    <li v-for="item in sperrInfo" :key="item.SPERRID"><strong>{{item.SPERRID}}</strong> angelegt durch {{item.BESITZER.ANSPRECHPARTNER}} ({{item.BESITZER.EMAIL}})</li>
                                </ul>
                        </base-alert>
                        </div>
                        <div :key="key+'ptn471'" class="col-lg-8">
                        <form  @submit.prevent="checkPlayer">
                            <div class="row">
                                    <div class="col-lg-6">
                                        <!----input-classes="form-control-alternative form-control-lg" --->
                                    <base-input alternative=""
                                                v-bind:readonly="isLoading"
                                                label="Vorname"
                                                class="col-form-label col-form-label-lg mb-0"
                                                placeholder="Vorname hier eingeben"
                                                :input-classes="['form-control-alternative','form-control-lg',errors.includes('V') ? 'is-invalid' : '']"
                                                v-model.trim="model.SPIELER.V"
                                    /></div>
                                    <div class="col-lg-6">
                                    <base-input alternative=""
                                                v-bind:readonly="isLoading"
                                                label="Nachname"
                                                class="col-form-label col-form-label-lg mb-0"
                                                placeholder="Nachname hier eingeben"
                                                :input-classes="['form-control-alternative','form-control-lg',errors.includes('N') ? 'is-invalid' : '']"
                                                v-model.trim="model.SPIELER.N"
                                    /></div>
                            </div>
                            <div class="row align-items-end">
                                <div class="col-lg-6">

                                <base-input
                                        label="Geburtstag"
                                        v-bind:readonly="isLoading"
                                        class="col-form-label col-form-label-lg mb-0 pb-0"
                                        placeholder="Geburtsdatum hier eingeben"
                                ><!---class="form-control form-control-alternative form-control-lg datepicker"--->
                                    <flat-pickr :key="key"
                                                 :config="config"
                                                 :class="['form-control','form-control-alternative','form-control-lg','datepicker', 'geburtstag', errors.includes('D') ? 'is-invalid' : '']"
                                                 v-model="model.SPIELER.D">
                                    </flat-pickr>
                                </base-input>
                                    <span class="text-muted text-xs">Eingabe mit Enter abschließen</span>
                                    <input type="hidden" id="birthday" v-on:blur="updateOnBlur" v-model="model.SPIELER.D">
                                </div>
                                <div class="col-lg-6 text-center">
                                    <input type="hidden" id="mrzdata" v-model="mrzData">
                                    <p><a href="#" v-on:click.prevent="expandSearchField = !expandSearchField">{{(expandSearchField) ? 'Weniger' : 'Mehr'}} Felder anzeigen</a></p>
                                </div>
                            </div>
                            <fade-transition>
                            <div v-show="expandSearchField || addPlayerForm" class="row">
                                <div class="col">
                                    <label class="form-control-label col-form-label col-form-label-lg">
                                        Land
                                    </label>
                                    <select v-model="model.SPIELER.A.L"
                                            v-bind:readonly="isLoading"
                                            class="mb-3 custom-select form-control form-control-alternative form-control-lg mb-0"
                                            :class="[errors.includes('AL') ? 'is-invalid' : '']">
                                        <!-- <option value="" disabled selected>Kunde</option> -->
                                        <option v-for="countrie in countries" :key="countrie.KBEZ1" :value="countrie.KBEZ1">{{ countrie.LBEZ }}
                                        </option>
                                    </select>
                                    <!--- hidden input field für set countrie in Scanner Middleware --->
                                    <input type="hidden" id="nationality" v-model="hiddenNationField">
                                </div>
                            </div>
                            </fade-transition>
                            <fade-transition>
                            <div class="row" v-show="expandSearchField || addPlayerForm">
                                <div class="col-lg-6">
                                    <base-input alternative=""
                                                label="Geburtsname"
                                                v-bind:readonly="isLoading"
                                                class="col-form-label col-form-label-lg mb-0"
                                                placeholder="Geburtsname hier eingeben"
                                                :input-classes="['form-control-alternative','form-control-lg',errors.includes('G') ? 'is-invalid' : '']"
                                                v-model="model.SPIELER.G"
                                    /></div>
                                <div class="col-lg-6">
                                    <base-input alternative=""
                                                label="Geburtsort"
                                                v-bind:readonly="isLoading"
                                                class="col-form-label col-form-label-lg mb-0"
                                                placeholder="Geburtsort hier eingeben"
                                                :input-classes="['form-control-alternative','form-control-lg',errors.includes('O') ? 'is-invalid' : '']"
                                                v-model="model.SPIELER.O"
                                    />
                                </div>
                            </div>
                            </fade-transition>
                        <div v-if="!addPlayerForm" class="row align-items-center" style="height: 100%;">
                            <div v-show="!checkUserAgent('Flutter')" class="col-lg-8">
                                <button name="checkplayer" class="btn btn-icon my-4 btn-primary" :disabled="isLoading" type="submit">
                                    <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="fas fa-search"></i></span>
                                    <span class="btn-inner--text">Spieler prüfen</span></button>
                                <base-button type="secondary" v-on:click="addOrEditPlayer">Sperren</base-button>
                            </div>
                        </div>
                        </form>
                        </div>
                    </div>
                    <hr v-if="addPlayerForm" class="my-4"/>
                    <!-- Address -->
                    <h6 v-if="addPlayerForm" class="heading-small text-muted mb-4">Ergänzende Spieler Informationen</h6>

                <div v-if="addPlayerForm" class="row">
                            <div class="col-lg-2">
                                <base-radio class="col-form-label col-form-label-lg mb-3"
                                            input-classes="form-control-alternative form-control-lg"
                                            name="Herr"
                                            v-model="model.INFO.title">
                                    Herr
                                </base-radio>
                            </div>
                            <div class="col-lg-2">
                                <base-radio class="col-form-label col-form-label-lg mb-3"
                                            input-classes="form-control-alternative form-control-lg"
                                            name="Frau"
                                            v-model="model.INFO.title">
                                    Frau
                                </base-radio>
                            </div>
                        </div>
                        <div v-if="addPlayerForm" class="row">
                            <div class="col-lg-4">
                                <base-input alternative=""
                                            label="Postleitzahl"
                                            type="number"
                                            class="col-form-label col-form-label-lg"
                                            placeholder="Postleitzahl hier eingeben"
                                            :input-classes="['form-control-alternative','form-control-lg',errors.includes('AP') ? 'is-invalid' : '']"
                                            v-model="model.SPIELER.A.P"
                                /></div>
                            <div class="col-lg-8">
                                <base-input alternative=""
                                            label="Wohnort"
                                            class="col-form-label col-form-label-lg"
                                            placeholder="Wohnort hier eingeben"
                                            :input-classes="['form-control-alternative','form-control-lg',errors.includes('AW') ? 'is-invalid' : '']"
                                            v-model="model.SPIELER.A.W"
                                /></div>
                        </div>
                        <div v-if="addPlayerForm" class="row">
                        <div class="col-lg-8">
                            <base-input alternative=""
                                        label="Straße"
                                        class="col-form-label col-form-label-lg"
                                        placeholder="Straße  hier eingeben"
                                        :input-classes="['form-control-alternative','form-control-lg',errors.includes('AS') ? 'is-invalid' : '']"
                                        v-model="model.SPIELER.A.S"
                            />
                        </div>
                            <div class="col-lg-2">
                                <base-input alternative=""
                                            label="Nr"
                                            class="col-form-label col-form-label-lg"
                                            placeholder="Nummer"
                                            :input-classes="['form-control-alternative','form-control-lg',errors.includes('AH') ? 'is-invalid' : '']"
                                            v-model="model.SPIELER.A.H"
                                /></div>
                            <div class="col-lg-2">
                                <base-input alternative=""
                                            label="Adresszusatz"
                                            class="col-form-label col-form-label-lg"
                                            placeholder="Adresszusatz"
                                            :input-classes="['form-control-alternative','form-control-lg',errors.includes('AZ') ? 'is-invalid' : '']"
                                            v-model="model.SPIELER.A.Z"
                                /></div>

                    </div>
                        <h6 v-if="addPlayerForm" class="heading-small text-muted mb-4">Einstellungen für Benachrichtigung</h6>
                        <div v-if="addPlayerForm" class="row">
                            <div class="col-lg-10">
                            Sofern der Spieler eine Bestätigung über seine Sperrung erhalten möchte, bitte hier eine E-Mail Adresse eingeben.
                            </div>
                        </div>
                        <div v-if="addPlayerForm" class="row">
                            <div class="col-lg-12">
                                <!-- :input-classes="[(isEmailValid === null) ? 'form-control-alternative' : '','form-control-lg']" -->
                                <base-input alternative
                                            input-classes="form-control-alternative form-control-lg"
                                            placeholder="E-Mail Adresse hier eingeben"
                                            :valid="isEmailValid"
                                            v-model="model.INFO.email"
                                /></div>
                        </div>
                        <h6 v-if="addPlayerForm" class="heading-small text-muted mb-4">Informationen zur Sperrdauer und Grund</h6>

                            <div v-if="addPlayerForm"  class="row">
                                <div class="col-lg-2">
                                    <base-radio class="col-form-label col-form-label-lg mb-3"
                                                :class="[errors.includes('SPERRGRUND') ? 'is-invalid-select' : '']"
                                                name="SELBST"
                                                v-model="model.SPERRGRUND">
                                        Selbstsperre
                                    </base-radio>
                                </div>
                                <div class="col-lg-2">
                                    <base-radio class="col-form-label col-form-label-lg mb-3"
                                                :class="[errors.includes('SPERRGRUND') ? 'is-invalid-select' : '']"
                                                name="FREMD"
                                                v-model="model.SPERRGRUND">
                                        Fremdsperre
                                    </base-radio>

                                </div>
                            </div>
                            <!--- ANFANG fristen ändern funktioniert nicht mit oasis ---->
                            <div class="row" v-if=" addPlayerForm && model.SPERRGRUND === 'SELBST'">
                                <div class="col-lg-5">
                                    <base-input
                                            label="Spielersperre endet am"
                                            class="col-form-label col-form-label-lg"
                                            placeholder="Bis wann möchte sich der Spieler sperren lassen?"
                                    >
                                        <flat-pickr slot-scope="{focus, blur}"
                                                    @on-open="focus"
                                                    @on-close="blur"
                                                    :config="configOasis"
                                                    class="form-control form-control-alternative form-control-lg datepicker"
                                                    v-model="model.FRIST_ENDE.DATUM">
                                        </flat-pickr>
                                    </base-input>
                                </div>
                            </div>
                            <!--- ENDE fristen ändern funktioniert nicht mit oasis ---->
                            <div v-if="addPlayerForm" class="row">
                                    <div class="col-lg-12">
                                        <label class="form-control-label">
                                            Grund für Sperre
                                        </label>
                                        <div v-for="(reason,i) in lockreasons" :key="i+key">
                                            <b-form-checkbox v-model="model.ANLASS"
                                                             ref="anlass"
                                                             name="anlass"
                                                             style="margin-bottom: 1rem; width: 100%;"
                                                             :disabled="(model.ANLASS.some(e => e.KBEZ1 === '99') && reason.KBEZ1 !== '99')"
                                                             :value="{ KBEZ1: reason.KBEZ1, LBEZ: reason.LBEZ, SORTNR: reason.SORTNR, ZULAESSIG: reason.ZULAESSIG }"
                                                             :button-variant="errors.includes('KBEZ1') ? 'outline-warning' : 'outline-primary'"
                                                             outline
                                                             button>
                                                {{reason.LBEZ}} <!--- <b> <i v-if="model.ANLASS.includes(reason)" class="fas fa-check"></i> </b> --->
                                            </b-form-checkbox></div>

                                    </div>
                            </div>

                        <hr v-if="addPlayerForm" class="my-4"/>
                        <!-- Address -->
                        <h6 v-if="addPlayerForm" class="heading-small text-muted mb-4">Rechtliches</h6>
                        <div v-if="addPlayerForm" class="row">
                            <div class="col-lg-12">
                                <base-alert :type="errors.includes('PRIVACY') ? 'warning' : 'secondary'" class="border-primary">
                                    <label class="form-control-label">
                                        Datenschutz
                                    </label>
                                    <br>
                                    <switches v-model="model.INFO.dataprivacy"
                                              theme="bootstrap"
                                              color="primary"
                                              style="padding-left: 2rem;"></switches>
                                    Mit  diesem  Antrag  willige  ich, {{ model.SPIELER.V }} {{ model.SPIELER.N }}  ausdrücklich  in  die  Erhebung,  Speicherung  und  Verarbeitung meiner  personenbezogenen  Daten  (Nachname,  Geburtsname,  Vorname/n,  Geburtsdatum, Geburtsort,  Anschrift)  zur  Durchsetzung  der  Spielersperre mittels  des  Spielersperrsystems OASIS ein.
                                </base-alert>
                            </div>
                        </div>
                        <div v-if="addPlayerForm" class="row">
                            <div class="col-lg-12">
                                <base-alert :type="errors.includes('APPROVE') ? 'warning' : 'secondary'" class="border-danger">
                                    <label class="form-control-label">
                                        Nachweise
                                    </label>
                                    <br>
                                    <switches v-model="model.INFO.approve"
                                              theme="bootstrap"
                                              color="primary"
                                              style="padding-left: 2rem;"></switches>
                                    Der Sperrantrag, sowie ein gültiger Identitätsnachweis (z.B. Ausweis oder Reisepass) liegen schriftlich vor und werden für eventuelle Rückfragen sicher verwahrt.
                                </base-alert>
                            </div>
                        </div>
                        <div v-if="addPlayerForm" class="row align-items-center" style="height: 100%;">
                            <div class="col-lg-12">
                                <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading" @click="submitPlayerData">
                                    <span :key="key+'bcn1'" class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                                    <span class="btn-inner--text">Spieler sperren</span></button>
                                <base-alert v-if="status.type !== ''" :type="status.type" autofocus>{{ status.message }}</base-alert>
                                <!---- Sperre aufheben nicht mehr in OASIS <base-button v-if="model.SPERRID" type="danger" icon="fas fa-user-minus" @click="openOrCloseDeleteModal">Spielersperre beenden</base-button> ---->
                            </div>

                        </div>

            <div class="row mt-4">
                <!--- <div v-if="status.type !== '' && status.type !== 'info'" class="col"> --->
                <div class="col" :key="'sperrid'+key">
                    <div class="mb-5" style="text-align: right;">
                        <!---- remove fertig/zurücksetzen button in footer january 23
                        <base-button v-if="reset"
                                     @click="setDefaultData"
                                     type="secondary">{{ clearButtonText }}</base-button> ---->
                    </div>
                    <a v-if="typeof model.SPERRID === 'undefined'" href="#" @click.prevent="$nextTick(() => {model.SPERRID = ''; key++;})">SperrID vorhanden? Mit SperrID suchen.</a>
                    <div v-else>
                        <base-input  v-model="model.SPERRID" label="Sperr ID" class="col-form-label col-form-label-lg"></base-input>
                        <base-button v-if="!addPlayerForm" @click="getLockDataWithSperrID(model.SPERRID)">Sperrid abrufen</base-button>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col">
                    <a href="#" @click.prevent="listLocks">An diesem Standort verwaltete Sperren anzeigen.</a>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col">
                    <h4>Anträge zum Ausdrucken</h4>
                    <ul>
                        <li><a href="#" @click.prevent="$store.dispatch('document/show',{path: 'https://socialguard.app/antrag/selbstsperre', type: 'pdf'})">Selbstsperre</a></li>
                        <li><a href="#" @click.prevent="$store.dispatch('document/show',{path: 'https://socialguard.app/antrag/fremdsperre', type: 'pdf'})">Fremdsperre</a></li>
                    </ul>
                    <h4><a href="https://service.socialguard.app/kb/faq.php?topicId=20" target="_blank">Anleitungen zur Durchführung der Sperrabfrage</a></h4>
                </div>
            </div>
        </card>
        <modal :show.sync="modals.multipleSperrID">
            <h6 slot="header" class="modal-title" id="modal-multiple-sperrid">Einträge von mehreren Glücksspielanbietern gefunden</h6>

            <p>Es gibt bereits mehrere Sperreinträge zu diesem Spieler. Aus Datenschutzgründen dürfen allerdings nur die Betiebe auf einen Sperreintrag zugreifen, die den jeweiligen Sperreintrag in Oasis hinzugefügt haben. Sollte Ihr Betrieb einen Sperrantrag für diesen Spieler verwaltet haben, wählen Sie bitte Ihr Unternehmen aus. Sofern kein Eintrag vorhanden ist, klicken Sie auf "abbrechen" und erstellen einen neuen Sperreintrag, sofern Ihnen das schriftliche Einverständnis der Person vorliegt.</p>

            <base-input v-model="company" placeholder="Nach Spielhalle oder Firma suchen"></base-input>
            <ul v-if="SPERRIDS.length > 0" id="multisperrid">
                <li v-for="item in filteredSPERRID" :key="item.id">
                    <a href="#" v-on:click.prevent="getLockDataWithSperrID(item.id)">{{item.description}}</a>
                </li>
            </ul>

            <template slot="footer">
                <base-button type="link" class="ml-auto" @click="modals.multipleSperrID = false">abbrechen
                </base-button>
            </template>
        </modal>
        <modal :show.sync="modals.oasisEntries"  @close="closeOasisEntries">
            <h6 slot="header" class="modal-title" id="modal-oasis-entries">Sperreinträge an Ihrem Standort</h6>
            <p> </p>
            <ul v-if="computedOasisEntries.length > 0" id="oasisentriesid">
                <li v-for="item in computedOasisEntries" :key="item.id">
                    <a href="#" v-on:click.prevent="getLockDataWithSperrID(item.SPERRID)">{{item.SPERRID}} - {{ item.SPIELER.V.slice(0,1) }}. {{ (item.SPIELER.N.length > 15 ) ? item.SPIELER.N.slice(0,15)+'...' : item.SPIELER.N }}</a>
                </li>
            </ul>
            <template slot="footer">
                <base-button type="link" class="ml-auto" @click="closeOasisEntries">schließen
                </base-button>
            </template>
        </modal>
        <modal :show.sync="modals.deleteLock" :showClose="false">
            <h6 slot="header" class="modal-title" id="modal-delete-lock">Sperreintrag löschen</h6>

            <p>Bitte geben Sie den Grund für das Aufheben der Spielersperre an.</p>
            <div v-for="(reason,i) in unlockreasons" :key="i+key+'a'">
                <b-form-checkbox v-model="model.AUFHEBUNGSGRUND"
                                 ref="aufhebungsgrund"
                                 name="aufhebungsgrund"
                                 style="margin-bottom: 1rem; width: 100%;"
                                 :value="reason.KBEZ1"
                                 button-variant="outline-primary"
                                 outline
                                 button>
                    {{reason.LBEZ}} <!--- <b> <i v-if="model.ANLASS.includes(reason)" class="fas fa-check"></i> </b> --->
                </b-form-checkbox></div>


            <template slot="footer">
                <base-button type="link" class="ml-auto" @click="openOrCloseDeleteModal">abbrechen</base-button>
                <base-button type="danger" icon="fas fa-user-minus" @click="runDeleteLock">Spielersperre beenden</base-button>
            </template>
        </modal>
      <modal :show.sync="modals.checkVIZ" :showClose="false">
        <h3 slot="header" class="modal-title" id="modal-viz-lock">Der Name ist möglicherweise nicht vollständig.</h3>
        <p>Überprüfen Sie die Vor- und Nachnamen auf dem Ausweis und korrigieren die Sperrabfrage wenn nötig. </p>

        <h4>Vorname: {{model.SPIELER.V}}</h4>
        <h4>Nachname: {{model.SPIELER.N}}</h4>
        <hr>

        <h3>Sind Vor- und Nachname korrekt?</h3>

        <template slot="footer">
          <base-button type="success" class="ml-auto" @click="checkPlayerWO">JA</base-button>
          <base-button type="danger" @click="openOrCloseVIZModal">NEIN</base-button>
        </template>
      </modal>
    </div>
</template>
<script>
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import { German } from "flatpickr/dist/l10n/de.js";
    import Switches from "vue-switches";
    import FadeTransition from "vue2-transitions/src/Fade/FadeTransition";
    //import { jsPDF } from "jspdf";


    export default {
        name: 'OasisSpielercheck',
        components: {FadeTransition, Switches, flatPickr},
        data() {
            return {
                hiddenNationField: '999',
                model: {
                    SPERRGRUND: '',
                    SPIELER: {
                        id: '',
                        V: '', //Vorname
                        N: '', //Nachname
                        G: '', //Geburtsname
                        D: '', //Geburtsdatum
                        O: '', //Geburtsort
                        A: {    //Anschrift
                            P: '',  //Postleitzahl
                            W: '', //Wohnort
                            S: '', //Straße
                            H: '', //Hausnummer
                            Z: '', //Adresszusatz
                            L: '999', //Ländercode
                        }
                    },
                    INFO: {
                        title: '',
                        dataprivacy: false,
                        approve: false,
                        email: ''
                    },
                    ANLASS: [],
                    AUFHEBUNGSGRUND: null,
                    FRIST_ENDE: {
                        DATUM: '',
                        'FORMAT-PATTERN': 'yyyy-MM-dd'
                    },
                },
                SPERRIDS: [],
                OasisEntries: [],
                config: {
                    dateFormat: 'Y-m-d',
                    altFormat: 'd.m.Y',
                    altInput: true,
                    allowInput: true,
                    locale: German
                },
                configOasis: {
                    dateFormat: 'd.m.Y',
                    altFormat: 'd.m.Y',
                    altInput: true,
                    allowInput: true,
                    locale: German
                },
                modals: {
                    multipleSperrID: false,
                    deleteLock: false,
                    oasisEntries: false,
                    checkVIZ: false
                },
                status: {
                    type: '',
                    message: '',
                    showBlockedInfo: false
                },
                countries: {
                    KBEZ1: "999",
                    KBEZ2: "-",
                    LBEZ: ""
                },
                lockreasons: {
                    KBEZ1: '',
                    LBEZ: '',
                    SORTNR: ''
                },
                unlockreasons: {
                    KBEZ1: '',
                    LBEZ: '',
                    SORTNR: ''
                },
                mrzData: null,
                company: '',
                isLoading: false,
                playerBlocked: false,
                addPlayerForm: false,
                expandSearchField: false,
                addPlayerMethod: 'POST',
                addPlayerLockMethod: 'POST',
                blockedMessage: 'Dieser Spieler ist für das Spiel gesperrt.',
                notblockedMessage: 'Dieser Spieler hat freien Zugang zum Glücksspielangebot.',
                errors: [],
                key: 1,
                bornAtField: null,
                sperrInfo: [],
                showSperrInfo: false
            }
        },
        created() {
            this.isLoading = true;
            this.setDefaultData();
              this.getData('countries').then(response =>{
                  this.countries = response.response.ITEM;
                  this.getData('lockreasons').then(response =>{
                      this.lockreasons = response.response.ITEM;
                      this.getData('unlockreasons').then(response =>{
                          this.unlockreasons = response.response.ITEM;
                          this.isLoading = false;
                      });
                  });
              });
            if (!this.$store.getters['location/isReady']) {
                this.$store.dispatch('location/getLocationCollection')
            }
        },
        computed: {
            activeProfile() {
                return this.$store.getters['profiles/showActiveProfile'];
            },
            activeLocation() {
                return this.$store.getters['authentication/location'];
            },
            activeLocationData() {
                return (this.$store.getters['location/isReady']) ? this.locationData : 'loading';
            },
            cardStyle() {
                return this.status.type;
                //return (this.status === 'success') ? (this.playerBlocked) ? 'danger' : 'success' : 'secondary';
            },
            clearButtonText() {
                return (this.status.type !== 'warning' ) ? "fertig" : "zurücksetzen" ;
                    },
            isEmailValid(){
                return (this.model.INFO.email === '') ? null : this.validEmail(this.model.INFO.email);
            },
            reset(){
                return this.model.SPIELER.V !== '' || this.model.SPIELER.N !== '' || this.model.SPIELER.D !== '' || this.model.SPIELER.O !== '' || this.model.SPIELER.G !== '' || typeof this.model.SPERRID !== 'undefined'
            },
            filteredSPERRID(){
                return (this.company === "") ? this.SPERRIDS : this.SPERRIDS.filter(item => {
                    return item.description.includes(this.company)
                });
            },
            computedOasisEntries() {
                return this.OasisEntries;
            }
        },
        methods: {
            updateOnBlur(e) {
                //this.$refs.pickr.fp.setDate(e.target.value, true, this.config.altFormat);
                    this.model.SPIELER.D = this.$options.filters.formatDateFromFormatToFormat('DD.MM.YYYY','YYYY-MM-DD',e.target.value);
                    this.key +=1;
            },
            closeOasisEntries() {
                    this.modals.oasisEntries = false;
                    this.key++;
                this.$forceUpdate();
            },
            listLocks() {
                this.modals.oasisEntries = true;
                this.OasisEntries = [];

                this.getLocks().then( data => {
                  if (typeof data.response.SPERRE !== 'undefined') this.OasisEntries = (Array.isArray(data.response.SPERRE)) ? data.response.SPERRE : [data.response.SPERRE];
                });
            },
            getLocks() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };

                    let url = process.env.VUE_APP_API_SERVER + '/oasis/locks/'+this.$store.getters['authentication/location'];

                    fetch(url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => { resolve({response});},
                            error => { reject(error); });
                });
            },
            getData(type) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };

                    let url = '/oasis/'+type+'/'+this.$store.getters['authentication/location'];

                    fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => { resolve({response});},
                            error => {
                            this.$store.dispatch('alert/error',error);
                            reject(error); });
                });
            },
            getLockData(id) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };

                    let url = '/oasis/lock/'+this.$store.getters['authentication/location']+'/'+id;

                    fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => { resolve({response});},
                            error => { reject(error); });
                });
            },
            checkPlayer() {
                this.status = {type: '', message: ''};
                this.errors = [];
                if(this.checkSearchValid()){
                    this.isLoading = true;
                    this.getPlayer().then(data => {
                        const meldungItem = data['MELDUNGSKATALOG-ITEM'] || data;
                        const { ART, MELDUNG, SCHLUESSEL } = meldungItem;
                        const codeMessage = ` [Code: ${SCHLUESSEL}]`;

                        const statusConfig = {
                          'I': {
                            playerBlocked: false,
                            status: {
                              type: 'success',
                              message: MELDUNG + codeMessage,
                              showBlockedInfo: true
                            }
                          },
                          'W': {
                            playerBlocked: true,
                            status: {
                              type: 'danger',
                              message: MELDUNG + codeMessage,
                              showBlockedInfo: true
                            },
                            sperrInfo: data['SPERRINFO'] || []
                          },
                          'E': {
                            playerBlocked: 'warning',
                            status: {
                              type: 'danger',
                              message: 'OASIS meldet:' + MELDUNG + codeMessage,
                              showBlockedInfo: false
                            }
                          }
                        };

                        const config = statusConfig[ART] || {
                          playerBlocked: false,
                          status: {
                            type: 'warning',
                            message: 'Undefinierte Rückmeldung von OASIS',
                            showBlockedInfo: false
                          }
                        };

                        if (SCHLUESSEL === '0052') {
                          config.status.type = 'warning'
                          config.playerBlocked = 'warning'
                        }

                        Object.assign(this, config);

                        // eslint-disable-next-line no-console
                        console.log(`${this.playerBlocked ? 'playerBlocked' : 'playerNotBlocked'}:${this.status.message}`);
                        this.isLoading = false;
                        this.key++;
                            }).catch( error => {
                        //this.status = {type: 'warning', message: error, showBlockedInfo: false};
                        this.$store.dispatch('alert/error', typeof error['error'] !== 'undefined' ? error['error'] : error);
                        this.isLoading = false;
                        this.key++; });

                } else {
                    this.status = {type: 'warning', message: 'Bitte geben Sie zunächst die Vorname, Nachname und Geburtsdatum an.', showBlockedInfo: false};
                    // eslint-disable-next-line no-console
                    console.log("warning:"+this.status.message);
                }

            },
            checkPlayerWO() {
                this.status = {type: '', message: ''};
                this.errors = [];
                this.openOrCloseVIZModal();
                this.isLoading = true;
                this.getPlayer().then(data => {
                  const meldungItem = data['MELDUNGSKATALOG-ITEM'] || data;
                  const { ART, MELDUNG, SCHLUESSEL } = meldungItem;
                  const codeMessage = ` [Code: ${SCHLUESSEL}]`;

                  const statusConfig = {
                    'I': {
                      playerBlocked: false,
                      status: {
                        type: 'success',
                        message: MELDUNG + codeMessage,
                        showBlockedInfo: true
                      }
                    },
                    'W': {
                      playerBlocked: true,
                      status: {
                        type: 'danger',
                        message: MELDUNG + codeMessage,
                        showBlockedInfo: true
                      },
                      sperrInfo: data['SPERRINFO'] || []
                    },
                    'E': {
                      playerBlocked: 'warning',
                      status: {
                        type: 'danger',
                        message: 'OASIS meldet:' + MELDUNG + codeMessage,
                        showBlockedInfo: false
                      }
                    }
                  };

                  const config = statusConfig[ART] || {
                    playerBlocked: false,
                    status: {
                      type: 'warning',
                      message: 'Undefinierte Rückmeldung von OASIS',
                      showBlockedInfo: false
                    }
                  };

                  if (SCHLUESSEL === '0052') {
                    config.status.type = 'warning'
                    config.playerBlocked = 'warning'
                  }

                  Object.assign(this, config);

                  // eslint-disable-next-line no-console
                  console.log(`${this.playerBlocked ? 'playerBlocked' : 'playerNotBlocked'}:${this.status.message}`);
                  this.isLoading = false;
                  this.key++;
                }).catch( error => {
                  //this.status = {type: 'warning', message: error, showBlockedInfo: false};
                  this.$store.dispatch('alert/error', typeof error['error'] !== 'undefined' ? error['error'] : error);
                  this.isLoading = false;
                  this.key++; });
            },
            getPlayer() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = {SPIELER: JSON.parse(JSON.stringify(this.model.SPIELER))};
                    if (senddata.SPIELER.A.L === '999') delete senddata.SPIELER.A.L;
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };

                    let url = '/oasis/check/'+this.$store.getters['authentication/location'];

                    fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            if (response.error)
                            {
                                reject(response)
                            } else {
                                resolve(response);
                            }
                        }, error => {reject(error)});
                })
            },
            addPlayer() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = JSON.parse(JSON.stringify(this.model));
                    delete senddata.SPERRID;
                    delete senddata.AUFHEBUNGSGRUND;
                    if(senddata.FRIST_ENDE.DATUM === '') {
                        delete senddata.FRIST_ENDE;
                    }
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };

                    let url = '/oasis/add/'+this.$store.getters['authentication/location'];

                    fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            if (response.error)
                            {
                                reject(response)
                            } else {
                                resolve(response);
                            }},
                            error => { reject(error); });
                });
            },
            editPlayer(id) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = JSON.parse(JSON.stringify(this.model));
                    delete senddata.SPERRID;
                    delete senddata.AUFHEBUNGSGRUND;
                    //if(!this.locationData().deadlineAllowed) {
                    //    delete senddata.FRIST_BEGINN;
                    //    delete senddata.FRIST_ENDE;
                    //}
                    const requestOptions = {
                        method: 'PUT',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };

                    let url = '/oasis/edit/'+this.$store.getters['authentication/location']+'/'+id;

                    fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                if (response.error)
                                {
                                    reject(response)
                                } else {
                                    resolve(response);
                                }
                            },
                                    error => { reject(error); });
                        });
            },
            objToString (obj) {
                return Object.entries(obj).reduce((str, [p, val]) => {
                    if (typeof val  === 'object' ) val = this.objToString(val);
                    if (val.length > 75) val = [val.slice(0, 75),val.slice(75,val.length)].join('\n')
                    return `${str}${p}::${val}\n`;
                }, '');
             },
            submitPlayerData(){
                if (this.checkSubmitValid()) {
                    this.isLoading = true;
                    this.$store.dispatch('alert/clear');
                    this.status = {type: '', message: ''};
                    // 1. Prüfe ob Spieler bereits existiert, wenn nein Add, sonst Edit
                    if(typeof this.model.SPERRID === 'undefined') {
                        this.addPlayer().then( data => {
                            if (data['MELDUNGSKATALOG-ITEM'].ART === 'I') {

                                /* todo: pdf export in sgscanner - chrome is already working
                                // Default export is a4 paper, portrait, using millimeters for units
                                const doc = new jsPDF();
                                let pdfname = "Bestaetigung_SperrID-"+ data.SPERRE.SPERRID +".pdf";
                                let text = 'Sperrbestätigung Oasis\n\n\n';
                                    text = text + this.objToString(data);
                                doc.text(text, 10, 10);
                                doc.save(pdfname); */
                                this.status = {type: 'success', message: data['MELDUNGSKATALOG-ITEM'].MELDUNG + ' Sperr ID: '+ data.SPERRE.SPERRID, showBlockedInfo: false };
                                this.addPlayerForm = false;
                            } else {
                                this.status = {type: 'danger', message: data['MELDUNGSKATALOG-ITEM'].MELDUNG, showBlockedInfo: false };
                            }
                            if (typeof data.incident !== "undefined") {
                                this.$store.dispatch('alert/error','Die E-Mail konnte möglicherweise nicht korrekt versendet werden: ' + data.incident)
                            }
                            this.isLoading = false;
                            this.key++;
                        }
                        ).catch(error => {
                            this.status = {type: 'danger', message: error, showBlockedInfo: false};
                            this.isLoading = false;
                            this.key++;
                        })
                    } else {
                        this.editPlayer(this.model.SPERRID).then( data => {
                                if (data['MELDUNGSKATALOG-ITEM'].ART === 'I') {
                                    this.status = {type: 'success', message: data['MELDUNGSKATALOG-ITEM'].MELDUNG, showBlockedInfo: false };
                                    this.addPlayerForm = false;
                                } else {
                                    this.status = {type: 'danger', message: data['MELDUNGSKATALOG-ITEM'].MELDUNG, showBlockedInfo: false };
                                }
                            this.isLoading = false;
                            this.key++;
                            }
                        ).catch(error => {
                            this.status = {type: 'danger', message: error, showBlockedInfo: false};
                            this.isLoading = false;
                            this.key++
                        })
                    }
                } else {
                    this.status = {type: 'warning', message: 'Bitte füllen Sie das Formular vollständig aus. Fehlende Felder wurden gekennzeichnet.'};
                    this.isLoading = false;
                    this.key++
                }
            },
            getLockDataWithSperrID(sperrid) {
                this.isLoading = true;
                this.$store.dispatch('alert/clear');
                this.modals.multipleSperrID = false;
                this.modals.oasisEntries = false;
                this.SPERRIDS = [];
                this.getLockData(sperrid).then(ldata => {
                        if (typeof ldata.response.SPERRE === 'undefined') {
                            let text = 'Der Spieler kann nicht editiert werden, da der Sperrantrag mit der ID ' + sperrid + ' nicht in Ihrem Unternehmen erstellt wurde. ' +
                                'Bitten Sie die Person sich an die Institution zu wenden, bei der sie sich gesperrt hat oder legen Sie eine neue Sperre an.';
                            this.$store.dispatch('alert/error', text);
                        } else {
                            this.model.SPIELER = ldata.response.SPERRE.SPIELER;
                            this.model.SPERRID = ldata.response.SPERRE.SPERRID;
                            this.model.SPERRGRUND = ldata.response.SPERRE.SPERRGRUND;
                            this.model.ANLASS = (Array.isArray(ldata.response.SPERRE.ANLASS)) ? ldata.response.SPERRE.ANLASS : [ldata.response.SPERRE.ANLASS];
                            if (ldata.response.SPERRE.FRIST_BEGINN) this.model.FRIST_BEGINN.DATUM = ldata.response.SPERRE.FRIST_BEGINN.DATUM;
                            if (ldata.response.SPERRE.FRIST_ENDE) this.model.FRIST_ENDE.DATUM = ldata.response.SPERRE.FRIST_ENDE.DATUM.split(' ')[0];
                            if(!this.addPlayerForm) this.addPlayerForm = true;
                        }

                        this.isLoading = false;
                        this.key++;
                    }
                ).catch(error => {
                    this.$store.dispatch('alert/error', error);
                    this.isLoading = false;
                    this.key++;
                });
            },
            addOrEditPlayer(){
                if (this.checkSearchValid()) {
                    if (!this.addPlayerForm || (this.addPlayerForm && this.status.type === 'warning')) {
                        this.isLoading = true;
                        this.key++;
                        this.status = {type: '', message: ''};
                        this.$store.dispatch('alert/clear');
                        this.getPlayer().then(data => {
                            if (data['MELDUNGSKATALOG-ITEM'].ART === 'W') {
                                //spieler existier => get data
                                //if min age not reached
                                if (data['MELDUNGSKATALOG-ITEM'].SCHLUESSEL === '9999') {
                                    this.addPlayerForm = false;
                                    this.status = {type: 'danger', message: data['MELDUNGSKATALOG-ITEM'].MELDUNG, showBlockedInfo: false};
                                } else  {
                                    if(typeof data['SPERRINFO'][0] !== 'undefined' || typeof data['SPERRINFO']['SPERRID'] !== 'undefined' ) {
                                        let sperrid = null;
                                        if (typeof data['SPERRINFO'][0] !== 'undefined')
                                        {
                                            data['SPERRINFO'].forEach(e => {
                                                this.SPERRIDS.push(
                                                    {
                                                        id: e.SPERRID,
                                                        name: e.BESITZER.NAME,
                                                        description: e.BESITZER.NAME+', '+e.BESITZER.ANSPRECHPARTNER+', '+e.BESITZER.TELEFON,
                                                    });
                                            });
                                            this.modals.multipleSperrID = true;
                                        } else {
                                            sperrid = data['SPERRINFO']['SPERRID'];
                                        }
                                        if (sperrid !== null){
                                            this.getLockDataWithSperrID(sperrid);
                                        }
                                    }
                                }
                            } else {
                                this.status = {type: 'info', message: 'Es besteht noch kein Eintrag zu diesem Spieler. Bitte füllen Sie das Formular anhand der Ausweisdaten vollständig und korrekt aus.', showBlockedInfo: false};
                                this.addPlayerMethod = 'POST';
                            }
                            this.isLoading = false;
                            this.key++;
                        }).catch(error => {
                            this.status = {type: 'danger', message: error, showBlockedInfo: false};
                            this.isLoading = false;
                            this.key++;
                            }
                        );
                        if (!this.addPlayerForm) this.addPlayerForm = !this.addPlayerForm;
                    }
                } else {
                    this.status = {type: 'warning', message: 'Bitte geben Sie zunächst Vorname, Nachname und Geburtsdatum an.', showBlockedInfo: false};
                    this.key++;
                }
            },
            runDeleteLockWithSperrID(id){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = JSON.parse(JSON.stringify({reason: this.model.AUFHEBUNGSGRUND}));
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };

                    let url = '/oasis/delete/'+this.$store.getters['authentication/location']+'/'+id;

                    fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            if (response.error)
                            {
                                reject(response)
                            } else {
                                resolve(response);
                            }},
                            error => { reject(error); });
                });
            },
            runDeleteLock() {
                this.isLoading = true;
                this.runDeleteLockWithSperrID(this.model.SPERRID).then(ldata => {
                    this.status = {type: (ldata['MELDUNGSKATALOG-ITEM'].ART === 'I') ? 'success' : 'warning', message: ldata['MELDUNGSKATALOG-ITEM'].MELDUNG, showBlockedInfo: false };
                        this.openOrCloseDeleteModal();
                        this.isLoading = false;
                    }
                ).catch(error => {
                    this.$store.dispatch('alert/error', error);
                    this.isLoading = false;
                });
            },
            setModelData(data, type) {
                let item = (type === 'model') ? this.model : this.playerLock;
                let out = {};
                Object.keys(item).forEach(function eachKey(key) {
                    out[key] = data[key];
                    }
                );
                if (type === 'model') {
                    this.model = out;
                } else {
                    this.playerLock = out;
                }
            },
            checkSearchValid() {
              const namelength = (this.model.SPIELER.N + this.model.SPIELER.V).length;
              if (this.model.SPIELER.V !== '' &&
                  this.model.SPIELER.N !== '' &&
                  this.model.SPIELER.D !== '' &&
                  ((namelength < 25 || namelength > 30) && namelength !== 39)) {
                return true;
              }

                this.errors = [];

                if (!this.model.SPIELER.V) {
                    this.errors.push('V');
                }
                if (!this.model.SPIELER.N) {
                    this.errors.push('N');
                }
                if (!this.model.SPIELER.D) {
                    this.errors.push('D');
                }

               if ((this.model.SPIELER.N + this.model.SPIELER.V).length !== 25 || (this.model.SPIELER.N + this.model.SPIELER.V).length !== 39) {
                 this.errors.push('V');
                 this.errors.push('N');
                 this.modals.checkVIZ = true;
               }

                this.key++;

                return false;
            },
            checkSubmitValid() {
                if (this.model.SPIELER.V !== ''
                    && this.model.SPIELER.N !== ''
                    && this.model.SPIELER.G !== ''
                    && this.model.SPIELER.D !== ''
                    && this.model.SPIELER.O !== ''
                    && this.model.SPIELER.A.P !== ''
                    && this.model.SPIELER.A.W !== ''
                    && this.model.SPIELER.A.S !== ''
                    && this.model.SPIELER.A.H !== ''
                    && this.model.SPIELER.A.L !== ''
                    && typeof this.model.ANLASS[0].KBEZ1 !== 'undefined'
                    && this.model.SPERRGRUND !== ''
                    && this.model.INFO.approve === true
                    && this.model.INFO.dataprivacy === true) {
                    return true;
                }

                this.errors = [];

                if (!this.model.SPERRGRUND) { this.errors.push('SPERRGRUND'); }
                if (!this.model.SPIELER.V) { this.errors.push('V'); }
                if (!this.model.SPIELER.N) { this.errors.push('N'); }
                if (!this.model.SPIELER.G) { this.errors.push('G'); }
                if (!this.model.SPIELER.D) { this.errors.push('D'); }
                if (!this.model.SPIELER.O) { this.errors.push('O'); }
                if (!this.model.SPIELER.A.P) { this.errors.push('AP'); }
                if (!this.model.SPIELER.A.W) { this.errors.push('AW'); }
                if (!this.model.SPIELER.A.S) { this.errors.push('AS'); }
                if (!this.model.SPIELER.A.H) { this.errors.push('AH'); }
                if (!this.model.SPIELER.A.L) { this.errors.push('AL'); }
                if (typeof this.model.ANLASS[0].KBEZ1 === 'undefined') { this.errors.push('KBEZ1'); }
                if (this.model.INFO.approve === false) { this.errors.push('APPROVE'); }
                if (this.model.INFO.dataprivacy === false) { this.errors.push('PRIVACY'); }

                this.key++;

                return false;
            },
            locationData() {
                return this.$store.getters['location/showLocationByIRI']('/api/locations/'+this.$store.getters['authentication/location']);
            },
            inputChange (text) {
                // your search method
                this.SPERRIDS = this.SPERRIDS.filter(item => item.description.includes(text));
                // now `items` will be showed in the suggestion list
            },
            openOrCloseDeleteModal() {
                this.modals.deleteLock = !this.modals.deleteLock;
                this.key++;
            },
            openOrCloseVIZModal() {
              this.modals.checkVIZ = !this.modals.checkVIZ;
              this.key++;
            },
            setDefaultData() {
                this.key++;
                //var d = new Date();
                //var year = d.getFullYear();
                //var month = d.getMonth();
                //var day = d.getDate();
                //var c = new Date(year + 1, month, day);
                this.model = {
                    SPERRGRUND: '',
                    SPIELER: {
                        id: '',
                        V: '', //Vorname
                        N: '', //Nachname
                        G: '', //Geburtsname
                        D: '', //Geburtsdatum
                        O: '', //Geburtsort
                        A: {    //Anschrift
                            P: '',  //Postleitzahl
                            W: '', //Wohnort
                            S: '', //Straße
                            H: '', //Hausnummer
                            Z: '', //Adresszusatz
                            L: '999' //Ländercode
                        }
                    },
                    INFO: {
                        title: '',
                        approve: false,
                        dataprivacy: false,
                        email: ''
                    },
                    ANLASS: [],
                    FRIST_ENDE: {
                        DATUM: '',
                        'FORMAT-PATTERN': 'dd.MM.yyyy'
                    }
                };





                /* Alterprüfung ab August 2021 über Backend



                var d = new Date();
                var year = d.getFullYear();
                var month = d.getMonth();
                var day = d.getDate();
                var c = new Date(year - this.locationData().minAge, month, day);
                this.config.maxDate = c;

                */

                this.isLoading= false;
                this.status = {type: '', message: '', showBlockedInfo: false};
                this.playerBlocked= false;
                this.addPlayerForm=false;
                this.mrzData = null;
                this.errors = [];
                this.SPERRIDS = [];
                this.modals= {
                    multipleSperrID: false
                };
            }
        }
    }
</script>
<style>
    ul#multisperrid{height:200px; }
    ul#multisperrid{overflow:hidden; overflow-y:scroll;}
</style>